import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IS_POLLING_REQUEST } from '@iw/core/init/interceptors';
import { ProfileService } from '@iw/core/services';
import { environment } from '@iw/environment';

import { ShellApi } from './index';
import { GetAccountsRes } from '../models';

@Injectable()
export class ShellApiService implements ShellApi {
  readonly #http = inject(HttpClient);
  readonly #profileService = inject(ProfileService);
  readonly #apiHost = environment.apiHost;

  getAccounts(isPolling = false): Observable<GetAccountsRes> {
    const api = this.#profileService.isActiveTreasurer()
      ? `${this.#apiHost}backoffice/accounts/`
      : `${this.#apiHost}accounts/`;

    const context = new HttpContext().set(IS_POLLING_REQUEST, isPolling);

    return this.#http.get<GetAccountsRes>(api, { context });
  }
}
